import { getLicenseFeeStatusById } from "@/utils/get-license-fee-status";
import { apiWobaBackend } from "../api-woba-backend";
import { EditLicenseFeeParams, LicenseFee, Pagination } from "./types";

export const licenseFeeService = {
  async createLicenseFee(data: any) {
    const response = await apiWobaBackend.post("/companies/license-fees", {
      ...data,
      companyId: Number(data.companyId),
      packageId: Number(data.packageId),
      startDate: data.startDate,
      endDate: data.endDate,
      tier: data.tier,
      members: Number(data.members),
      notes: data.notes,
      amount: data.amount,
      exemptionAmount: data.exemptionAmount,
      installments: data.installments,
      paymentProvider: Number(data.paymentProvider),
      paymentMethod: Number(data.paymentMethod),
      setupFee: data.setupFee,
    });

    return response.data;
  },

  async listLicenseFees({
    company,
    startDate,
    endDate,
    status,
    take,
    page,
  }: {
    company?: number | string;
    startDate?: string;
    endDate?: string;
    status?: string;
    take?: number;
    page?: number;
  }): Promise<{ data: LicenseFee[]; pagination: Pagination }> {
    const search = new URLSearchParams();

    if (company) {
      search.append("companyId", company.toString());
    }

    if (startDate) {
      search.append("startDate", startDate);
    }

    if (endDate) {
      search.append("endDate", endDate);
    }
    if (status) {
      search.append("status", getLicenseFeeStatusById(status).toString());
    }

    if (take) {
      search.append("take", take?.toString());
    }

    if (page) {
      search.append("page", page?.toString());
    }

    const response = await apiWobaBackend.get(
      `/companies/license-fees?${search.toString()}`,
    );

    return response.data;
  },

  async getLicenseFeeById(id: number): Promise<LicenseFee> {
    const response = await apiWobaBackend.get(`/companies/license-fees/${id}`);

    return response.data;
  },

  async updateLicenseFee(id: number, data: EditLicenseFeeParams) {
    await apiWobaBackend.patch(`/companies/license-fees/${id}`, data);
  },

  async deleteLicenseFee(id: number) {
    await apiWobaBackend.delete(`/companies/license-fees/${id}`);
  },
};
